import styled, { css } from 'styled-components';

import SyncIcon from '@mui/icons-material/Sync';

export const Container = styled.div<{ width?: string; height?: string; fullWidth?: boolean; $maxWidth?: string }>`
  position: relative;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  max-width: ${({ $maxWidth }) => $maxWidth};

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
`;

export const LoadingIcon = styled(SyncIcon)`
  @keyframes rotating {
    from {
      transform: rotate(359deg);
    }
    to {
      transform: rotate(0deg);
    }
  }

  animation: rotating 1s linear infinite;

  position: absolute;
  right: 27px;
  bottom: 4px;
  width: 22px;
  height: 22px;

  color: ${({ theme: { palette } }) => palette.grey[200]};
`;
